<nav id="navHeader" class="navbar navbar-expand-lg bg-dark p-1 nav-header-pfm" [ngClass]="{ 'fixed-top': headerType == HeaderType.Login }">
  <div class="container-fluid p-0">
    <div class="col-lg-3 col-sm-6 px-2 px-lg-5 px-md-5 col-md-3">
      <a class="navbar-brand m-0 p-0" [routerLink]="'/member-portal/dashboard'">
        <img loading="lazy" [src]="headerStyles.logo!" width="4023" height="1451" [ngClass]="{'header-logo-verify-financial-profile-dashboard': showClassVerify, 'header-logo': !showClassVerify}" />
      </a>
    </div>
    <div *ngIf="headerType == HeaderType.Basic" class="mx-2 mx-md-5"><a class="text-decoration-none text-white fw-bold" href="{{brandResources.loginURL}}" target="_blank">Login</a></div>
  </div>
</nav>
